<template>
  <InnerCardInfo
    v-if="contractData"
    :label="localStorage.translations.pages['setting-personal_area'].sections['kontrakt']"
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya'],
        value: dateEndFormatted || '-',
      },
    ]"
    :images="contractData.file"
    need-image-domain
    pdf
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot />
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'ContractPdf',
  props: { contract: Object, editReady: Boolean },
  components: { InnerCardInfo },
  data: () => ({
    contractData: null,
    dateEnd: null,
    dateEndFormatted: null,
  }),
  watch: {
    contract() {
      this.getData()
    },
    dateEnd(val) {
      this.dateEndFormatted = this.formatDate(this.dateEnd)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.contract) {
        this.contractData = JSON.parse(this.contract.data)
        this.dateEnd = this.contractData.date_end
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return (day ? day + '.' : '') + (month ? month + '.' : '') + year
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>
